import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['hiddenContent']

  show() {
    this.hiddenContentTarget.classList.remove("hidden")
  }

  hide() {
    this.hiddenContentTarget.classList.add("hidden")
  }
}
